import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-background-pattern',
  templateUrl: './background-pattern.component.html',
  styleUrl: './background-pattern.component.css',
  imports: [CommonModule],
})
export class BackgroundPatternComponent {}
